import React from 'react';
import OrganizationListItem from './OrganizationListItem';

const OrganizationList: React.FunctionComponent<any> = ({organizations, onClick}) => {
  const listItems = organizations ? organizations.map((organization: any, index: number) =>
    <OrganizationListItem  onClick={onClick} key={`list-item-${index}`} organization={organization} />
  ) : null;

  return (
    <div className="overflow-y-auto p-2.5 md:px-6" style={{height: 'calc(100% - 120px)'}}>
      {listItems}
    </div>
  )
}

export default OrganizationList;